export default {
	SUBMIT_LEAVE_MESSAGE : 'leaveMessage/submitLeaveMessage',//提交留言信息
}


// WEBPACK FOOTER //
// ./src/utils/api.js